import { useField } from "formik";
import { EfsMelcoEfsModelsSchemaListItem } from "melco-shared-logic";
import { SelectDataSource } from "./SelectDataSource";
import { SelectSourceModifier } from "./SelectSourceModifier";

type DynamicFilenameRuleProps = {
  isAdvancedOptionsEnabled: boolean;
  dataAssignments: EfsMelcoEfsModelsSchemaListItem[];
  sourceModifierName?: string;
};

export const DynamicFilenameRule: React.FC<DynamicFilenameRuleProps> = ({
  isAdvancedOptionsEnabled,
  dataAssignments,
  sourceModifierName,
}) => {
  const [{ value: type }] = useField("type");

  if (type !== "Dynamic") {
    return null;
  }

  return (
    <>
      <SelectDataSource
        dataAssignments={dataAssignments}
        name="format_detail_id"
      />

      {isAdvancedOptionsEnabled && (
        <SelectSourceModifier name={sourceModifierName ?? "exception_id"} />
      )}
    </>
  );
};
